import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/Login',
        component: resolve => require(['@/page/Login.vue'], resolve),
    }, {
        path: '/',
        component: resolve => require(['@/page/index.vue'], resolve),
    },
    {
        path: '/index',
        component: resolve => require(['@/page/index.vue'], resolve),
        redirect: '/mini_app/manage_banner',
        children: [
            //首页
            // -添加轮播图-轮播图-首页
            {
                path: '/home/add_banner',
                component: resolve => require(['@/page/home/add_banner.vue'], resolve)
            },
            // 轮播图 - 首页
            {
                path: '/home/home_banner',
                component: resolve => require(['@/page/home/home_banner.vue'], resolve)
            },
            // 添加首页板块标题
            {
                path: '/home/add_recommend',
                component: resolve => require(['@/page/home/add_recommend.vue'], resolve)
            },
            // 首页关于我们
            {
                path: '/home/about_us',
                component: resolve => require(['@/page/home/about_us.vue'], resolve)
            },
            // 首页弹窗广告
            {
                path: '/home/adver_dialog',
                component: resolve => require(['@/page/home/adver_dialog.vue'], resolve)
            },
            // 首页帮助中心
            {
                path: '/home/help_center',
                component: resolve => require(['@/page/home/help_center.vue'], resolve)
            },
            // 首页帮助中心 - 添加
            {
                path: '/home/add_help',
                component: resolve => require(['@/page/home/add_help.vue'], resolve)
            },
            // ————————————————————————————————————————————————————
            // 服务
            // 服务 - 服务列表
            {
                path: '/server/list',
                component: resolve => require(['@/page/server/list.vue'], resolve)
            },
            // 服务 - 服务列表 - 添加
            {
                path: '/server/add_server',
                component: resolve => require(['@/page/server/add_server.vue'], resolve)
            },
            // 服务 - 服务分类
            {
                path: '/server/category',
                component: resolve => require(['@/page/server/category.vue'], resolve)
            },
            // 服务 - 服务分类 - 添加
            {
                path: '/server/add_category',
                component: resolve => require(['@/page/server/add_category.vue'], resolve)
            },
            // 服务 - 服务列表 - 已预约服务
            {
                path: '/server/subscribe_server',
                component: resolve => require(['@/page/server/subscribe_server.vue'], resolve)
            },
            // 服务 - 服务列表 - 已预约服务详情
            {
                path: '/server/subscribe_server_detail',
                component: resolve => require(['@/page/server/subscribe_server_detail.vue'], resolve)
            },
            // 服务 - 报名表单
            {
                path: '/server/enroll_form',
                component: resolve => require(['@/page/server/enroll_form.vue'], resolve)
            },
            // 服务 - 报名表单 - 添加
            {
                path: '/server/add_form',
                component: resolve => require(['@/page/server/add_form.vue'], resolve)
            },
            // 服务 - 标签
            {
                path: '/server/server_tag_list',
                component: resolve => require(['@/page/server/server_tag_list.vue'], resolve)
            },
            // 服务 - 新增/标签
            {
                path: '/server/add_tag',
                component: resolve => require(['@/page/server/add_tag.vue'], resolve)
            },
            // 活动列表
            {
                path: '/activity/activity_manage',
                component: resolve => require(['@/page/activity/activity_manage.vue'], resolve)
            },
            // 活动列表 - 添加活动
            {
                path: '/activity/add_activity',
                component: resolve => require(['@/page/activity/add_activity.vue'], resolve)
            },
            // 活动 - 报名表单 - 已报名用户
            {
                path: '/user/enroll_user',
                component: resolve => require(['@/page/user/enroll_user.vue'], resolve)
            },
            // 活动 - 报名表单 - 已报名用户详情
            {
                path: '/user/enroll_user_detail',
                component: resolve => require(['@/page/user/enroll_user_detail.vue'], resolve)
            },
            // 新闻 - 新闻文章
            {
                path: '/news/article',
                component: resolve => require(['@/page/news/article.vue'], resolve)
            },
            // 新闻 - 新闻文章 - 添加文章
            {
                path: '/news/add_article',
                component: resolve => require(['@/page/news/add_article.vue'], resolve)
            },
            // 新闻 - 文章分类
            {
                path: '/news/category',
                component: resolve => require(['@/page/news/category.vue'], resolve)
            },
            // 新闻 - 文章分类 - 添加分类
            {
                path: '/news/add_category',
                component: resolve => require(['@/page/news/add_category.vue'], resolve)
            },
            // 用户 - 用户列表
            {
                path: '/user/user',
                component: resolve => require(['@/page/user/user.vue'], resolve)
            },
            // 用户 - 用户列表 - 用户详情
            {
                path: '/user/user_detail',
                component: resolve => require(['@/page/user/user_detail.vue'], resolve)
            },
            // 用户 - 用户协议和隐私协议
            {
                path: '/user/agreement',
                component: resolve => require(['@/page/user/agreement.vue'], resolve)
            },
            //系统
            {
                path: '/set_up/role_list',
                component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
            }, // 系统角色 - 系统
            {
                path: '/set_up/add_role',
                component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
            }, // 添加角色-系统角色 - 系统
            {
                path: '/set_up/menu_list',
                component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
            }, // 系统菜单 - 系统
            {
                path: '/set_up/add_menu',
                component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/user_list',
                component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/addStaff',
                component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
        ]
    },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js